import { createFeature, createReducer, on } from '@ngrx/store';

import { Config, initialStatus, LoadingStatus } from '@features/termination/interfaces';

import * as fromActions from '../../actions';

export const configFeatureName = 'configInformation';

export interface ConfigState {
  config: Config;
  configLoadingStatus: LoadingStatus;
}

export const initialState: ConfigState = {
  config: {
    recipient: [''],
    sender: '',
    subject: '',
    formname: '',
  },
  configLoadingStatus: initialStatus,
};

export const ConfigReducers = createReducer(
  initialState,
  on(fromActions.ConfigLoad, (state: ConfigState): ConfigState => ({
    ...state,
    configLoadingStatus: {
      ...initialStatus,
      isLoading: true,
    },
  })),
  on(fromActions.ConfigLoadComplete, (state: ConfigState, { config }): ConfigState => ({
    ...state,
    configLoadingStatus: {
      ...initialStatus,
      isLoaded: true,
    },
    config,
  })),
  on(fromActions.ConfigLoadError, (state: ConfigState, { error }): ConfigState => ({
    ...state,
    configLoadingStatus: {
      ...initialStatus,
      error,
    },
  })),
);

export const configFeature = createFeature({
  name: configFeatureName,
  reducer: ConfigReducers,
});
